/* eslint-disable arrow-parens */

import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  GET_AGILLINKONLINE_FIRMLIST_GQL,
  GET_AGILLINKONLINE_FIRM_CLIENTLIST_GQL,
  GET_AGILLINKONLINE_GLACCOUNTS_GQL,
  SET_CREATE_AGILLINKONLINE_GQL,
  SET_AGILLINKONLINE_POST_TRANSACTIONS_GQL,
  SET_AGILLINKONLINE_POST_INTERCOMPANY_TRANSACTIONS_GQL,
  SET_AGILLINKONLINE_POST_SUMMARY_INTERCOMPANY_TRANSACTIONS_GQL,
  SET_SYNC_AGILLINKONLINE_CATEGORIES_GQL,
  SET_UPDATE_MAPPED_CREDITCARD_GQL,
  SET_UPDATE_AGILLINKONLINE_TEAMTAGSYNCSTATUS_GQL,
  GET_AGILLINKONLINE_HISTORY_GQL,
  SET_STORE_TRANSACTION_SYNC_TYPE_GQL,
  GET_TRANSACTION_SYNC_STATUS_VALUE_GQL,
  SET_AGILLINKONLINE_POST_SUMMARY_TRANSACTIONS_GQL,
  GET_JOURNAS_LIST_GQL
} from '@/graphql/agilLinkOnline.gql';

export default {
  namespaced: true,

  state: {
    agilLinkOnlineFirmsList: null,
    agilLinkOnlineFirmClientsList: null,
    agilLinkOnlineGlAccountsList: null,
    createdAgilLinkOnlineRecord: null,
    syncedAgilLinkOnlineTransaction: null,
    syncedAgilLinkOnlineInterCompanyTransaction: null,
    syncedAgilLinkOnlineCategories: null,
    mappedCreditCard: null,
    teamTagToggled: null,
    agilLinkOnlineHistory: null,
    transactionSyncTypeStored: null,
    transactionSyncStatusValue: null,
    syncedAgilLinkOnlineSummaryTransaction: null,
    syncedAgilLinkOnlineSummaryInterCompanyTransaction: null,
    agilLinkJournalEntries: null,
  },

  mutations: {
    GET_AGILLINKONLINE_FIRMLIST(state, payload) {
      state.agilLinkOnlineFirmsList = payload;
    },
    GET_AGILLINKONLINE_FIRM_CLIENTLIST(state, payload) {
      state.agilLinkOnlineFirmClientsList = payload;
    },
    GET_AGILLINKONLINE_GLACCOUNTS(state, payload) {
      state.agilLinkOnlineGlAccountsList = payload;
    },
    SET_CREATE_AGILLINKONLINE(state, payload) {
      state.createdAgilLinkOnlineRecord = payload;
    },

    SET_AGILLINKONLINE_POST_TRANSACTIONS(state, payload) {
      state.syncedAgilLinkOnlineTransaction = payload;
    },
    SET_AGILLINKONLINE_POST_INTERCOMPANY_TRANSACTIONS(state, payload) {
      state.syncedAgilLinkOnlineInterCompanyTransaction = payload;
    },
    SET_AGILLINKONLINE_POST_SUMMARY_TRANSACTIONS(state, payload) {
      state.syncedAgilLinkOnlineSummaryTransaction = payload;
    },
    SET_AGILLINKONLINE_POST_SUMMARY_INTERCOMPANY_TRANSACTIONS(state, payload) {
      state.syncedAgilLinkOnlineSummaryInterCompanyTransaction = payload;
    },
    SET_SYNC_AGILLINKONLINE_CATEGORIES(state, payload) {
      state.syncedAgilLinkOnlineCategories = payload;
    },
    SET_UPDATE_MAPPED_CREDITCARD(state, payload) {
      state.mappedCreditCard = payload;
    },
    SET_UPDATE_AGILLINKONLINE_TEAMTAGSYNCSTATUS(state, payload) {
      state.teamTagToggled = payload;
    },
    GET_AGILLINKONLINE_HISTORY(state, payload) {
      state.agilLinkOnlineHistory = payload;
    },
    SET_STORE_TRANSACTION_SYNC_TYPE(state, payload) {
      state.transactionSyncTypeStored = payload;
    },
    GET_TRANSACTION_SYNC_STATUS_VALUE(state, payload) {
      state.transactionSyncStatusValue = payload;
    },
    GET_JOURNAS_LIST(state, payload) {
      state.agilLinkJournalEntries = payload;
    }
  },

  actions: {
    async getAgilLinkOnlineFirmsList({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_AGILLINKONLINE_FIRMLIST_GQL,
          fetchPolicy: 'no-cache',
        })
        .then((agilLinkOnlineFirmsListData) => {
          commit('GET_AGILLINKONLINE_FIRMLIST', agilLinkOnlineFirmsListData.data.getAgilLinkOnlineFirmsList);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getAgilLinkOnlineFirmClients({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_AGILLINKONLINE_FIRM_CLIENTLIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((agilLinkOnlineFirmClientsListData) => {
          commit('GET_AGILLINKONLINE_FIRM_CLIENTLIST', agilLinkOnlineFirmClientsListData.data.getAgilLinkOnlineFirmClients);
        })
        .catch(agilLinkOnlineFirmClientsListErr => {
          commit('GET_AGILLINKONLINE_FIRMLIST', { status: 'failure', error: agilLinkOnlineFirmClientsListErr.message });
        });
    },
    async getAgilLinkOnlineGlAccounts({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_AGILLINKONLINE_GLACCOUNTS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((agilLinkOnlineGlAccountsData) => {
          commit('GET_AGILLINKONLINE_GLACCOUNTS', agilLinkOnlineGlAccountsData.data.getAgilLinkOnlineGlAccounts);
        })
        .catch(agilLinkOnlineGlAccountsErr => {
          commit('GET_AGILLINKONLINE_GLACCOUNTS', { status: 'failure', error: agilLinkOnlineGlAccountsErr.message });
        });
    },
    async createAgilLinkOnline({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_CREATE_AGILLINKONLINE_GQL,
          variables: payload,
        })
        .then((createAgilLinkOnlineData) => {
          commit('SET_CREATE_AGILLINKONLINE', createAgilLinkOnlineData.data.createagilLinkOnline);
        })
        .catch(createAgilLinkOnlineErr => {
          commit('SET_CREATE_AGILLINKONLINE', { status: 'failure', error: createAgilLinkOnlineErr.message });
        });
    },
    async syncAgilLinkOnlineTransaction({ commit }, payload) {
      apolloClient
        .mutate({
          mutation: SET_AGILLINKONLINE_POST_TRANSACTIONS_GQL,
          variables: payload,
          context:{
            headers: {"operationname": "postAgilLinkOnlineTransactions"}
          },
        })
        .then((syncAgilLinkOnlineTransactionData) => {
          commit('SET_AGILLINKONLINE_POST_TRANSACTIONS', syncAgilLinkOnlineTransactionData.data.postAgilLinkOnlineTransactions);
        })
        .catch(syncAgilLinkOnlineTransactionErr => {
          commit('SET_AGILLINKONLINE_POST_TRANSACTIONS', { status: 'failure', error: syncAgilLinkOnlineTransactionErr.message });
        });
    },
    async syncAgilLinkOnlineInterCompanyTransaction({ commit }, payload) {
      apolloClient
      .mutate({
        mutation: SET_AGILLINKONLINE_POST_INTERCOMPANY_TRANSACTIONS_GQL,
        variables: payload,
        context:{
          headers: {"operationname": "postAgilLinkOnlineInterCompanyTransactions"}
        },
      })
      .then((syncAgilLinkOnlineInterCompanyTransactionData) => {
        commit('SET_AGILLINKONLINE_POST_INTERCOMPANY_TRANSACTIONS', syncAgilLinkOnlineInterCompanyTransactionData.data.postAgilLinkOnlineInterCompanyTransactions);
      })
      .catch(syncAgilLinkOnlineInterCompanyTransactionErr => {
        commit('SET_AGILLINKONLINE_POST_INTERCOMPANY_TRANSACTIONS', { status: 'failure', error: syncAgilLinkOnlineInterCompanyTransactionErr.message });
      });
    },
    async postAgilLinkOnlineSummaryInterCompanyTransactions({ commit}, payload) {
      apolloClient
      .mutate({
        mutation: SET_AGILLINKONLINE_POST_SUMMARY_INTERCOMPANY_TRANSACTIONS_GQL,
        variables: payload,
        context:{
          headers: {"operationname": "postAgilLinkOnlineSummaryInterCompanyTransactions"}
        },
      })
      .then((postAgilLinkOnlineSummaryInterCompanyTransactionsData) => {
        commit('SET_AGILLINKONLINE_POST_SUMMARY_INTERCOMPANY_TRANSACTIONS', postAgilLinkOnlineSummaryInterCompanyTransactionsData.data.postAgilLinkOnlineSummaryInterCompanyTransactions);
      })
      .catch(postAgilLinkOnlineSummaryInterCompanyTransactionsErr => {
        commit('SET_AGILLINKONLINE_POST_SUMMARY_INTERCOMPANY_TRANSACTIONS', { status: 'failure', error: postAgilLinkOnlineSummaryInterCompanyTransactionsErr.message });
      });
    },
    async postAgilLinkOnlineSummaryTransactions({ commit }, payload) {
      apolloClient
        .mutate({
          mutation: SET_AGILLINKONLINE_POST_SUMMARY_TRANSACTIONS_GQL,
          variables: payload,
          context:{
            headers: {"operationname": "postAgilLinkOnlineSummaryTransactions"}
          },
        })
        .then((syncAgilLinkOnlineSummaryTransactionsData) => {
          commit('SET_AGILLINKONLINE_POST_SUMMARY_TRANSACTIONS', syncAgilLinkOnlineSummaryTransactionsData.data.postAgilLinkOnlineSummaryTransactions);
        })
        .catch(syncAgilLinkOnlineSummaryTransactionsErr => {
          commit('SET_AGILLINKONLINE_POST_SUMMARY_TRANSACTIONS', { status: 'failure', error: syncAgilLinkOnlineSummaryTransactionsErr.message });
        });
    },
    async syncAgilLinkOnlineCategories({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_SYNC_AGILLINKONLINE_CATEGORIES_GQL,
          variables: {
            companyId: payload.companyId,
          },
        })
        .then((syncAgilLinkOnlineCategoriesData) => {
          commit('SET_SYNC_AGILLINKONLINE_CATEGORIES', syncAgilLinkOnlineCategoriesData.data.syncAgilLinkOnlineCategories);
        })
        .catch(syncAgilLinkOnlineCategoriesErr => {
          commit('SET_SYNC_AGILLINKONLINE_CATEGORIES', { status: 'failure', error: syncAgilLinkOnlineCategoriesErr.message });
        });
    },
    async updateMappedCreditCardForAgilLinkOnline({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_UPDATE_MAPPED_CREDITCARD_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((updateMappedCreditCardForAgilLinkOnlineData) => {
          commit('SET_UPDATE_MAPPED_CREDITCARD', updateMappedCreditCardForAgilLinkOnlineData.data.updateMappedCreditCardForAgilLinkOnline);
        })
        .catch(updateMappedCreditCardForAgilLinkOnlineErr => {
          commit('SET_UPDATE_MAPPED_CREDITCARD', { status: 'failure', error: updateMappedCreditCardForAgilLinkOnlineErr.message });
        });
    },
    async updateAgilLinkOnlineTeamTagSyncStatus({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_UPDATE_AGILLINKONLINE_TEAMTAGSYNCSTATUS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((updateAgilLinkOnlineTeamTagSyncStatusData) => {
          commit('SET_UPDATE_AGILLINKONLINE_TEAMTAGSYNCSTATUS', updateAgilLinkOnlineTeamTagSyncStatusData.data.updateAgilLinkOnlineTeamTagSyncStatus);
        })
        .catch(updateAgilLinkOnlineTeamTagSyncStatusErr => {
          commit('SET_UPDATE_AGILLINKONLINE_TEAMTAGSYNCSTATUS', { status: 'failure', error: updateAgilLinkOnlineTeamTagSyncStatusErr.message });
        });
    },
    async getAgilLinkOnlineHistory({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: GET_AGILLINKONLINE_HISTORY_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getAgilLinkOnlineHistoryData) => {
          commit('GET_AGILLINKONLINE_HISTORY', getAgilLinkOnlineHistoryData.data.getAgilLinkOnlineHistory);
        })
        .catch(getAgilLinkOnlineHistoryErr => {
          commit('GET_AGILLINKONLINE_HISTORY', { status: 'failure', error: getAgilLinkOnlineHistoryErr.message });
        });
    },
    // stores sync type value in database
    async storeTransactionSyncType({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_STORE_TRANSACTION_SYNC_TYPE_GQL,
          variables: payload,
        })
        .then((storeTransactionSyncTypeData) => {
          if(storeTransactionSyncTypeData.data.storeTransactionSyncType.status === 'success') {
            commit('GET_TRANSACTION_SYNC_STATUS_VALUE', {status: "success", data: JSON.stringify(payload.transactionSyncType)});
          }
          commit('SET_STORE_TRANSACTION_SYNC_TYPE', storeTransactionSyncTypeData.data.storeTransactionSyncType);
        })
        .catch(storeTransactionSyncTypeErr => {
          commit('SET_STORE_TRANSACTION_SYNC_TYPE', { status: 'failure', error: storeTransactionSyncTypeErr.message });
        });
    },
    async getTransactionSyncTypeValue({ commit}, payload) {
      await apolloClient
        .query({
          query: GET_TRANSACTION_SYNC_STATUS_VALUE_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getTransactionSyncTypeValueData) => {
          commit('GET_TRANSACTION_SYNC_STATUS_VALUE', getTransactionSyncTypeValueData.data.getTransactionSyncTypeValue);
        })
        .catch(getTransactionSyncTypeValueErr => {
          commit('GET_TRANSACTION_SYNC_STATUS_VALUE', { status: 'failure', error: getTransactionSyncTypeValueErr.message });
        });
    },
    async getJournalsList({commit}, payload) {
      await apolloClient
        .query({
          query: GET_JOURNAS_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
          context:{
            headers: {"operationname": "getJournalsList"}
          },
        })
        .then((getJournalsListData) => {
          commit('GET_JOURNAS_LIST', getJournalsListData.data.getJournalsList);
        })
        .catch(getJournalsListErr => {
          commit('GET_JOURNAS_LIST', { status: 'failure', error: getJournalsListErr.message });
        });
    }   
  },

  getters: {
    agilLinkOnlineFirmsList: state => state.agilLinkOnlineFirmsList,
    agilLinkOnlineFirmClientsList: state => state.agilLinkOnlineFirmClientsList,
    agilLinkOnlineGlAccountsList: state => state.agilLinkOnlineGlAccountsList,
    createdAgilLinkOnlineRecord: state => state.createdAgilLinkOnlineRecord,
    syncedAgilLinkOnlineTransaction: state => state.syncedAgilLinkOnlineTransaction,
    syncedAgilLinkOnlineCategories: state => state.syncedAgilLinkOnlineCategories,
    mappedCreditCard: state => state.mappedCreditCard,
    teamTagToggled: state => state.teamTagToggled,
    agilLinkOnlineHistory: state => state.agilLinkOnlineHistory,
    transactionSyncTypeStored: state => state.transactionSyncTypeStored,
    transactionSyncStatusValue: state => state.transactionSyncStatusValue,
    syncedAgilLinkOnlineSummaryTransaction: state => state.syncedAgilLinkOnlineSummaryTransaction,
    agilLinkJournalEntries: state => state.agilLinkJournalEntries,
    syncedAgilLinkOnlineInterCompanyTransaction: state => state.syncedAgilLinkOnlineInterCompanyTransaction,
    syncedAgilLinkOnlineSummaryInterCompanyTransaction: state => state.syncedAgilLinkOnlineSummaryInterCompanyTransaction
  },
};
